import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import en from '../../../international/translations/en';
import CancelWrapper from '../CancelWrapper/CancelWrapper';
import brandToString from '../../../utils/brandToString';
import daysFromNowUntil from '../../../utils/daysFromNowUntil';
import { parseBillingDate } from '../../../utils/getPlanSubHeadingUtils';
import { showCancellationProgress } from '../../../redux/Cancel/subscription';

class CancelLanding extends Component {
  static propTypes = {
    params: PropTypes.object,
    subscription: PropTypes.object,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  componentDidMount() {
    this.props.showCancellationProgress(1);
    if (window.analytics) {
      window.analytics.page('Cancel Funnel', 'Landing Page');
    }
  }

  keepAccount() {
    const goToSubscription = () => window.location.assign('/account/subscription');
    if (window.analytics) {
      window.analytics.track('Kept Account', { location: 'cancel-funnel-landing-page' }, {}, goToSubscription);
    } else {
      goToSubscription();
    }
  }

  cancelSubscription() {
    if (window.analytics) {
      window.analytics.track(
        'Continued To Cancel',
        { location: 'cancel-funnel-landing-page' }
      );
    }
    this.context.router.history.push(`/cancel/${this.props.match.params.subscriptionId}/survey`);
  }

  render() {
    const { subscription } = this.props;
    const { onTrial } = subscription;
    const copy = onTrial ? en.cancellation_funnel.freetrial_landing : en.cancellation_funnel.landing;
    return (
      <CancelWrapper splash="landing">
        <Helmet
          title={copy.meta_title}
          meta={[
            { name: 'description', content: copy.meta_description }
          ]}
        />
        <h1 className="cancel-landing__title">{copy.title}</h1>
        <hr />
        {
          onTrial ? (
            <div>
              <div className="cancel-landing__free-trial_text">
                {copy.free_trial_text(daysFromNowUntil(subscription.periodEnd), brandToString())}
              </div>
              <div className="cancel-landing__free-trial_billing_info">
                {copy.free_trial_billing_info(parseBillingDate(subscription.periodEnd), brandToString())}
              </div>
            </div>
          ) : null
        }
        <div>
          <button
            onClick={this.keepAccount}
            className="cancel__button--keep-premium"
          >{en.cancellation_funnel.action_keep_account}
          </button>
          <button className="cancel__ghost-button" onClick={this.cancelSubscription.bind(this)}>{en.cancellation_funnel.action_continue}</button>
        </div>
      </CancelWrapper>
    );
  }
}

export default connect(state => ({
  subscription: state.subscription.currentSubscriptionForBrand,
}), { showCancellationProgress })(CancelLanding);

